export enum DatatableRowActivationType {
  KEYDOWN = 'keydown',
  CLICK = 'click',
  DOUBLE_CLICK = 'dblclick'
}
